export default __webpack_public_path__ + "static/media/modal_wave.76963eae.png";